export default __webpack_public_path__ + "static/media/kitten1S.682a95e3.webp";